import { useLocation } from "react-router-dom"

const tabs = [
    { href: "/leie", tekst: "Leie" },
    { href: "/praktisk-info", tekst: "Praktisk info" },
    { href: "/huskeliste", tekst: "Ankomst & avreise" },
    { href: "/anbefalinger", tekst: "Anbefalinger" },
]

export function BottomTabBar() {
    const location = useLocation()
    const erAktiv = (href: string) => location.pathname.startsWith(href)

    return (
        <nav className="bottomTabBar">
            {tabs.map((tab) => (
                <a
                    key={tab.href}
                    href={tab.href}
                    className={erAktiv(tab.href) ? "bottomTab bottomTabAktiv" : "bottomTab"}
                >
                    {tab.tekst}
                </a>
            ))}
        </nav>
    )
}
